import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";
import { liveUsageResourceMetadataSelector } from "@/store/live-usage-mgmt/selectors/resource-type-data/resource-metadata/liveUsageResourceMetadataSelector";

export const liveUsageResourceMetadataFilteredResourcesCountSelector = (
  state: RootState,
  resourceType: ResourceType,
): number | undefined => {
  const data = liveUsageResourceMetadataSelector(state, resourceType);

  return data?.filtered_resources_count;
};
